/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Order_ConfirmationsInputs */

const en_nav_order_confirmations = /** @type {(inputs: Nav_Order_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order confirmations`)
};

/**
* | output |
* | --- |
* | "Order confirmations" |
*
* @param {Nav_Order_ConfirmationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_order_confirmations = /** @type {((inputs?: Nav_Order_ConfirmationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Order_ConfirmationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_order_confirmations(inputs)
});